import React from "react"

import { fixedHeader } from "./FixedHeader.module.scss"

const FixedHeader = ({ label, value }) => (
  <div className={fixedHeader}>
    <label>{label}</label>
    <span>{value}</span>
  </div>
)

export default FixedHeader
